import React from 'react';

const About: React.FC = () => {
  return (
    <div className="section-padding">
      <div className="container">
        {/* Header Section */}
        <div className="section-title text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-800 dark:text-white mb-4">
            About the Creator
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Learn about the vision and mission behind ImanVerse
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Personal Information Card */}
          <div className="card mb-8">
            <div className="text-center mb-8">
              <div className="w-24 h-24 mx-auto bg-gradient-to-br from-emerald-400 to-green-500 rounded-2xl flex items-center justify-center text-white text-3xl shadow-lg mb-6">
                👨‍💻
              </div>
              <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
                Mohammad Shafee ur rahaman
              </h2>
              <p className="text-gray-600 dark:text-gray-400 text-lg">
                Developer & Creator of ImanVerse
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Education & Background */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4 flex items-center gap-3">
                  <span className="text-2xl">🎓</span>
                  Education & Background
                </h3>
                <div className="space-y-3 text-gray-600 dark:text-gray-400">
                  <p>Computer Science Engineering Student</p>
                  <p>Passionate about Islamic Studies & Technology</p>
                  <p>Dedicated to creating meaningful digital solutions</p>
                </div>
              </div>

              {/* Mission */}
              <div>
                <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4 flex items-center gap-3">
                  <span className="text-2xl">🎯</span>
                  My Mission
                </h3>
                <div className="space-y-3 text-gray-600 dark:text-gray-400">
                  <p>Bridging technology with Islamic education</p>
                  <p>Making Islamic knowledge accessible to everyone</p>
                  <p>Supporting spiritual growth through digital means</p>
                </div>
              </div>
            </div>
          </div>

          {/* Vision for ImanVerse */}
          <div className="card mb-8">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6 text-center">
              Why I Created ImanVerse
            </h2>
            
            <div className="space-y-6">
              {/* Quran Accessibility */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center text-blue-600 dark:text-blue-400 text-xl flex-shrink-0">
                  📖
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Quran Accessibility for Everyone
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    I created this platform to make the Quran easily accessible to everyone - especially new Muslims, 
                    those seeking to understand Islam, and anyone who wants to read the Quran in English with proper 
                    translation and transliteration. It's not just about reading, but truly understanding the meaning 
                    behind Allah's words.
                  </p>
                </div>
              </div>

              {/* Audio Quran */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-xl flex items-center justify-center text-green-600 dark:text-green-400 text-xl flex-shrink-0">
                  🎧
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Audio Quran for Busy Lives
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    Understanding that many people are constantly on the move - traveling, commuting, or working - 
                    I integrated audio recitations so you can listen to the Quran anywhere, anytime. This ensures 
                    that the connection with Allah's words remains strong throughout your daily activities.
                  </p>
                </div>
              </div>

              {/* Prayer Guidance */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/30 rounded-xl flex items-center justify-center text-purple-600 dark:text-purple-400 text-xl flex-shrink-0">
                  🕌
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Step-by-Step Prayer Learning
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    Salah is the foundation of our faith, and many struggle with learning the proper way to pray. 
                    I've included comprehensive step-by-step guides for all daily prayers, special prayers like Tahajjud, 
                    and essential duas to help establish a strong connection with Allah through proper worship.
                  </p>
                </div>
              </div>

              {/* Emotional Support */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/30 rounded-xl flex items-center justify-center text-amber-600 dark:text-amber-400 text-xl flex-shrink-0">
                  💫
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Emotional & Spiritual Support
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    Life brings various emotional challenges - anger, anxiety, depression, loneliness, uncertainty. 
                    The "My Mood" section provides Islamic guidance and specific duas for different emotional states, 
                    helping you turn to Allah in every situation and find peace through remembrance of Him.
                  </p>
                </div>
              </div>

              {/* Prophets Knowledge */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-indigo-100 dark:bg-indigo-900/30 rounded-xl flex items-center justify-center text-indigo-600 dark:text-indigo-400 text-xl flex-shrink-0">
                  🌟
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Learning About the Prophets
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    Every Muslim should know about the 25 prophets mentioned in the Quran. I've created a comprehensive 
                    section with family trees, relationships, and stories to help understand the lineage from Prophet 
                    Adam (AS) to Prophet Muhammad ﷺ, making this essential knowledge easily accessible.
                  </p>
                </div>
              </div>

              {/* Knowledge Testing */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-xl flex items-center justify-center text-red-600 dark:text-red-400 text-xl flex-shrink-0">
                  ❓
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                    Interactive Learning & Self-Assessment
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                    The quiz system allows users to test their Islamic knowledge, identify areas for improvement, 
                    and reinforce their learning through interactive engagement. This makes the journey of acquiring 
                    Islamic knowledge more engaging and effective.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Final Message */}
          <div className="card bg-gradient-to-br from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 border-2 border-emerald-200 dark:border-emerald-800 text-center">
            <h3 className="text-2xl font-bold text-emerald-800 dark:text-emerald-300 mb-4">
              My Commitment to You
            </h3>
            <p className="text-emerald-700 dark:text-emerald-200 text-lg leading-relaxed">
              "I am committed to continuously improving ImanVerse and adding more valuable features to support 
              your spiritual journey. This platform is my humble contribution to the Ummah, created with the 
              intention of making Islamic knowledge accessible, understandable, and beneficial for everyone."
            </p>
            <div className="mt-6 text-emerald-600 dark:text-emerald-400 font-semibold">
              - Mohammad Shafee
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .container {
            padding: 0 20px;
          }
        }
        
        @media (max-width: 480px) {
          .container {
            padding: 0 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default About;